module.exports = __webpack_public_path__ + "static/media/piping.3ffdce72.png";